import assetClassificationActions from "../../../actions/assetClassificationActions";
import assetClassificationInputFields from "./assetClassificationInputFields";
import generateEntityCreator from "../../../hocs/generateEntityCreator";

const AssetClassificationCreator = generateEntityCreator({
  entityActions: assetClassificationActions,
  returnRoutePath: "asset-classifications-listing",
  fields: assetClassificationInputFields,
});

export default AssetClassificationCreator;
